"use strict";
// @ts-ignore
try {
    self['workbox:strategies:5.1.4'] && _();
}
catch (e) { }
